<template>
  <div class="form_field flex_field border-bottom items-center">
    <div class="label_container">
      <label for="">È la tua auto? Aggiungila a Le Mie Auto!</label>
      <div class="sub_label-italic">
        La sezione all’interno dell’area personale di Quattroruote nella quale avere sempre sotto
        controllo le informazioni e gestire le scadenze della tua auto
      </div>
    </div>
    <div class="input_container radio_container">
      <label class="input-radio">
        <span>Si</span>
        <input type="radio" checked="checked" name="add_car" value="1" />
        <span class="checkmark"></span>
      </label>
      <label class="input-radio">
        <span>No</span>
        <input type="radio" checked="checked" name="add_car" value="0" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FormFieldProperty',
}
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldProperty.vue